import { FC, ReactNode } from "react"
import "./telegramPreview.css"

export interface InlineKeyboardButton {
  text: string
  url?: string
  style?: "primary" | "success" | "danger"
}

export interface InlineKeyboardMarkup {
  inline_keyboard: InlineKeyboardButton[][]
}

interface TelegramBubbleProps {
  senderName?: string
  replyMarkup?: InlineKeyboardMarkup
  children: ReactNode
}

/**
 * Outer styled container mimicking a Telegram Web dark-theme message bubble.
 * Renders sender name, slot for media+text content, a decorative timestamp,
 * and an optional inline keyboard below the bubble.
 */
export const TelegramBubble: FC<TelegramBubbleProps> = ({
  senderName = "Bot",
  replyMarkup,
  children,
}) => {
  const now = new Date()
  const time = `${now.getHours().toString().padStart(2, "0")}:${now
    .getMinutes()
    .toString()
    .padStart(2, "0")}`

  return (
    <div className="tg-preview-wrapper">
      <div className="tg-message-group">
        <div className="tg-bubble">
          <div className="tg-bubble-sender">🤖 {senderName}</div>
          {children}
          <div className="tg-bubble-time">{time}</div>
        </div>
        {replyMarkup && replyMarkup.inline_keyboard?.length > 0 && (
          <div className="tg-inline-keyboard">
            {replyMarkup.inline_keyboard.map((row, rowIdx) => (
              <div key={rowIdx} className="tg-inline-keyboard-row">
                {row.map((btn, colIdx) => (
                  <a
                    key={colIdx}
                    className={[
                      "tg-inline-keyboard-btn",
                      btn.style ? `tg-inline-keyboard-btn--${btn.style}` : "",
                    ]
                      .join(" ")
                      .trim()}
                    href={btn.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {btn.text}
                  </a>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
